import { AlertTriangle, CheckCircle2 } from 'lucide-react';

/**
 * CE QUI SERA RÉELLEMENT REMPLI, ET PAR QUOI.
 *
 * ⚠️ CE COMPOSANT NE DÉCIDE RIEN. Il affiche `couverture`, calculée par la fonction même
 * qui décide du remplissage (`services/gabarit_couverture`, ATL-5). Une couverture
 * recalculée ici finirait par diverger de ce que le PDF fait vraiment, et c'est alors
 * l'écran qui mentirait — la panne la plus coûteuse, parce qu'on ne la découvre qu'après
 * avoir fait signer.
 */
const SOURCES = {
  zone: { texte: 'posé à la main', ton: 'text-marque' },
  jeton: { texte: 'par son placeholder', ton: 'text-neutral-500' },
  libelle: { texte: 'par le libellé du document', ton: 'text-neutral-500' },
  aucune: { texte: 'ne sera pas rempli', ton: 'text-amber-700' },
};

export default function CouvertureDesChamps({ jetons }) {
  if (!jetons) return null;
  const inconnus = jetons.inconnus || [];
  const sansCouverture = jetons.sans_couverture || [];

  // ⚠️ CE BLOC RESTE SUR LES CINQ JETONS DU DOCUMENT, PAS SUR LES QUATORZE CHAMPS.
  //
  // `couverture` porte desormais les quatorze, parce que le panneau des valeurs a besoin
  // d une pastille par ligne. Ce bloc-ci repond a une autre question — « ce que le
  // document, tel qu il est ecrit, sait remplir » — et l etendre y ferait entrer les
  // cases et la signature sous la mention « ne sera pas rempli », qui n a aucun sens pour
  // un consentement. Deux lectures de la meme donnee, deux perimetres, assumes.
  const connus = jetons.connus || [];
  const couverture = Object.fromEntries(
    Object.entries(jetons.couverture || {}).filter(([cle]) => connus.includes(cle)));

  return (
    <div className="space-y-1.5">
      {/* ⚠️ LE BANDEAU QUI MANQUAIT LE PLUS. Un jeton qu'on ne sait pas remplir n'est pas
          rejeté à l'import : le PDF se dépose, s'active et se signe. Il part simplement
          au client avec les accolades, et rien ne le disait. */}
      {inconnus.length > 0 && (
        <div className="rounded-md border border-amber-200 bg-amber-50/70 p-2 flex items-start gap-1.5"
             data-testid="gabarit-jetons-inconnus">
          <AlertTriangle className="w-3.5 h-3.5 text-amber-600 shrink-0 mt-0.5" />
          <p className="text-[11px] text-amber-900">
            <strong>{inconnus.length} placeholder{inconnus.length > 1 ? 's' : ''} non
            reconnu{inconnus.length > 1 ? 's' : ''}</strong> : {inconnus.map((j) => `{{${j}}}`).join(', ')}.
            {inconnus.length > 1 ? ' Ils resteront tels quels' : ' Il restera tel quel'} dans
            le mandat signé, accolades comprises.
          </p>
        </div>
      )}

      {sansCouverture.length > 0 && (
        <div className="rounded-md border border-amber-200 bg-amber-50/60 p-2 flex items-start gap-1.5"
             data-testid="gabarit-sans-couverture">
          <AlertTriangle className="w-3.5 h-3.5 text-amber-600 shrink-0 mt-0.5" />
          <p className="text-[11px] text-amber-900">
            Ni placeholder, ni libellé, ni zone pour{' '}
            {sansCouverture.map((j) => `{{${j}}}`).join(', ')} : le mandat partira sans{' '}
            {sansCouverture.length > 1 ? 'ces informations' : 'cette information'}.
            {' '}Posez-{sansCouverture.length > 1 ? 'les' : 'la'} à la main depuis l&apos;onglet Plan.
          </p>
        </div>
      )}

      {Object.keys(couverture).length > 0 && (
        <div className="rounded-md border border-neutral-200 bg-neutral-50 p-2"
             data-testid="gabarit-couverture">
          <p className="text-[10.5px] text-neutral-500 mb-1 flex items-center gap-1">
            <CheckCircle2 className="w-3 h-3 text-neutral-400" /> Ce qui remplit quoi
          </p>
          <ul className="space-y-0.5">
            {Object.entries(couverture).map(([champ, c]) => (
              <li key={champ} className="text-[10.5px] flex items-baseline gap-1.5"
                  data-testid={`couverture-${champ}`}>
                <code className="text-neutral-400 shrink-0">{champ}</code>
                <span className={SOURCES[c.source]?.ton}>
                  {SOURCES[c.source]?.texte || c.source}
                </span>
                {/* ⚠️ CE QUI EST ÉCARTÉ SE DIT. Quand une zone prime sur un placeholder,
                    l'opérateur doit comprendre pourquoi son {{client_nom}} ne s'écrit
                    plus là où il l'avait mis — sinon il croit à une panne et le remet. */}
                {c.ecarte?.length > 0 && (
                  <span className="text-neutral-400">
                    (remplace {c.ecarte.map((e) => SOURCES[e]?.texte || e).join(' et ')})
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
